<template>
  <div class="catalog-menu-tree">
    <div
      v-for="(node, index) in nodes"
      :key="node.id || 'new-' + index"
      class="tree-node"
    >
      <div class="tree-node__row">
        <span class="tree-node__title">
          <span v-if="node.icon_url" class="tree-node__icon">
            <img :src="node.icon_url" :alt="node.title" />
          </span>
          {{ node.title || "(без названия)" }}
          <span class="tree-node__badge">
            {{ node.type === "link" ? "Ссылка" : "Текст" }}
          </span>
        </span>
        <span class="tree-node__actions">
          <va-button
            flat
            small
            color="gray"
            icon="fa fa-arrow-up"
            title="Выше"
            :disabled="index === 0"
            @click="$emit('move-up', parent, index)"
          />
          <va-button
            flat
            small
            color="gray"
            icon="fa fa-arrow-down"
            title="Ниже"
            :disabled="index === nodes.length - 1"
            @click="$emit('move-down', parent, index)"
          />
          <va-button
            flat
            small
            color="gray"
            icon="fa fa-pencil"
            title="Редактировать"
            @click="$emit('edit', node)"
          />
          <va-button
            flat
            small
            color="gray"
            icon="fa fa-plus"
            title="Добавить подпункт"
            @click="$emit('add-child', node)"
          />
          <va-button
            flat
            small
            color="gray"
            icon="fa fa-trash"
            title="Удалить"
            @click="$emit('delete', node, parent, index)"
          />
        </span>
      </div>
      <div v-if="node.children && node.children.length" class="tree-node__children">
        <catalog-menu-tree
          :nodes="node.children"
          :categories="categories"
          :parent="node"
          @edit="$emit('edit', $event)"
          @add-child="$emit('add-child', $event)"
          @delete="(n, p, i) => $emit('delete', n, p, i)"
          @move-up="(p, i) => $emit('move-up', p, i)"
          @move-down="(p, i) => $emit('move-down', p, i)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CatalogMenuTree",
  props: {
    nodes: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: Array,
      default: () => [],
    },
    parent: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style scoped>
.catalog-menu-tree {
  padding-left: 0;
}
.tree-node {
  margin-bottom: 0.25rem;
}
.tree-node__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0.75rem;
  background: #f8f9fa;
  border-radius: 4px;
}
.tree-node__title {
  display: flex;
  align-items: center;
}
.tree-node__icon {
  width: 20px;
  height: 20px;
  margin-right: 0.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.tree-node__icon img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.tree-node__title .tree-node__badge {
  margin-left: 0.5rem;
  padding: 0.15rem 0.5rem;
  font-size: 0.75rem;
  background: #e9ecef;
  color: #495057;
  border-radius: 4px;
}
.tree-node__actions {
  display: flex;
  gap: 0.25rem;
}
.tree-node__children {
  margin-left: 1.5rem;
  margin-top: 0.25rem;
}
</style>
